<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <div style="text-align: left" class="p-3 mb-2 ">
        <h5>Appointment List
          <b-button class="float-right" @click="handleback" variant="danger" style="margin-bottom:-10px;">
              <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
          </b-button> 
          <hr/>
        </h5>
      </div>
      <div class="panel-body" style="margin:10px;margin-top:-10px;">
        <div>
          <div class="md-4">
              <b-card-text class="mycard">
                <table style="line-height: 1;">
                  <tr style="">
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Date</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">01-01-2019</td>
                    <td>
                      <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Tag No</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">17</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Owner Name</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">sudesh sharma</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Village/City</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">kolhapur</td>
                  </tr>
                </table>
              </b-card-text>
          </div><hr/>
          <div class="md-4">
              <b-card-text class="mycard" style="padding-top: 1px">
                <table>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Date</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">23-05-2019</td>
                    <td>
                      <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                    </td>
                  </tr>
                  <tr></tr>

                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Tag No</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">34</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Owner Name</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">sachin shinde</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Village/City</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">Ratnagiri</td>
                  </tr>
                </table>
              </b-card-text>
          </div>
          <hr/>
          <div class="md-4">
              <b-card-text class="mycard" style="padding-top: 5px">
                <table>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Date</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">12-08-2020</td>
                    <td>
                      <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Tag No</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">13</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Owner Name</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">Rahul Yadav</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">Village/City</td>
                    <td width="1%" style="text-align: left;font-size: 18px;font-family: Arial, Helvetica, sans-serif;">:</td>
                    <td width="54%" style="text-align: left;font-size: 16px;font-family: Arial, Helvetica, sans-serif;">Sangli</td>
                  </tr>
                </table>
              </b-card-text>
          </div>
        </div><hr/>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  methods:{
    viewHandle(){
      this.$router.push('/home/view_Appointment');
    },
    handleback(){
      this.$router.go(-1);
    },
    add(){
      this.$router.push('/home/Appointment_list');
    },
     handleBack(){
            this.$router.go(-1);
        }
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
body {
  line-height: 1;
}
*{
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
